<app-cabecera></app-cabecera>

<app-menu></app-menu>

<router-outlet></router-outlet>

<app-pie-pagina></app-pie-pagina>